export default __webpack_public_path__ + "static/media/Monger-HUD-Readout (VSO).118116e6.jpg";